// extracted by mini-css-extract-plugin
export var activeTab = "StockTakeWrapper-module--activeTab--c3qxG";
export var container = "StockTakeWrapper-module--container--NI8Ea";
export var tabs = "StockTakeWrapper-module--tabs--vkCnY";